import { createAction } from '@reduxjs/toolkit';

export const NAV_STACK_PUSH_ACTION_TYPE = 'saga/navStackPush';
export const navStackPushAction = createAction(NAV_STACK_PUSH_ACTION_TYPE);
